import MinimalLayout from './MinimalLayout';

export default MinimalLayout;
